

















































































































































import moment from 'moment-timezone'
import {
  DeviceManagementActions,
  DeviceManagementWizardStages,
  DeviceManagementDeviceNames,
  DeviceManagementComponents,
  DeviceManagementAvailableDevice,
  DeviceManagementDefaultAvailableDevice,
  DeviceManagementWizardNextButtonActionNames,
  DeviceManagementWizardBackButtonActionNames,
} from '@/constants/device-management'
import { Timeouts } from '@/constants/timeouts'
import DeviceManagementConnectGateway from '@/components/device-management/DeviceManagementConnectGateway.vue'
import DeviceManagementSelectDevices from '@/components/device-management/DeviceManagementSelectDevices.vue'
import DeviceManagementConnectDevices from '@/components/device-management/DeviceManagementConnectDevices.vue'
import DeviceManagementCheckConnectivity from '@/components/device-management/DeviceManagementCheckConnectivity.vue'
import DeviceManagementRebootGateway from '@/components/device-management/DeviceManagementRebootGateway.vue'
import DeviceManagementSetupWifi from '@/components/device-management/DeviceManagementSetupWifi.vue'

export default {
  components: {
    DeviceManagementConnectGateway,
    DeviceManagementSelectDevices,
    DeviceManagementConnectDevices,
    DeviceManagementCheckConnectivity,
    DeviceManagementRebootGateway,
    DeviceManagementSetupWifi,
  },

  data() {
    return {
      chosenDeviceManagementAction: null,
      deviceManagementWizardStages: null,
      deviceManagementWizardCurrentStageIndex: 0,
      deviceManagementWizardCurrentSelectedDeviceIndex: 0,
      deviceManagementWizardIsInProgress: false,
      currentGatewayId: '',
      allDevices: [],
      currentGatewayPollInterval: null,
      isSendingGatewayPollRequest: false,
      hasGatewayConnectionFailure: false,
    }
  },

  computed: {
    deviceManagementActions() {
      return [
        DeviceManagementActions.CreatePackage,
        DeviceManagementActions.AddDevices,
        DeviceManagementActions.RemoveDevices,
        DeviceManagementActions.ReplaceDevices,
        DeviceManagementActions.RebootGateWay,
        DeviceManagementActions.SetupWifi,
      ]
    },
    deviceNames() {
      return [
        DeviceManagementDeviceNames.Tracker,
        DeviceManagementDeviceNames.Scale,
        DeviceManagementDeviceNames.PulseOximeter,
        DeviceManagementDeviceNames.Thermometer,
        DeviceManagementDeviceNames.BloodPressureMonitor,
        DeviceManagementDeviceNames.Inhaler,
      ]
    },
    deviceManagementWizardCurrentStage() {
      return this.deviceManagementWizardStages[this.deviceManagementWizardCurrentStageIndex]
    },
    deviceManagementWizardProgressIndicator() {
      return this.deviceManagementWizardStages.map((stage, index) => ({
        ...stage,
        hasLink: index < this.deviceManagementWizardStages.length - 1,
        isCurrent: index === this.deviceManagementWizardCurrentStageIndex,
        isComplete: index < this.deviceManagementWizardCurrentStageIndex,
      }))
    },
    deviceManagementWizardSelectedDevices() {
      return this.allDevices.filter(device => device.isSelected)
    },
    deviceManagementWizardActionButtons() {
      return [
        {
          text: this.isFirstWizardStage ? 'Start Again' : 'Go Back',
          isNeutral: true,
          isOutlined: this.isFirstWizardStage,
          color: this.isFirstWizardStage ? 'red' : 'light-grey',
          action: this.isFirstWizardStage
            ? () => this.initDeviceManagementWizard(this.chosenDeviceManagementAction)
            : this.deviceManagementWizardBackButtonAction,
          isDisabled: !this.canGoToPreviousWizardStage,
          isShown: this.showPreviousWizardStageButton,
        },
        {
          text: this.isLastWizardStage ? 'Done' : 'Next',
          color: 'primary',
          action: this.deviceManagementWizardNextButtonAction,
          isDisabled: !this.canProgressToNextWizardStage,
          isShown: true,
        },
      ]
    },
    canProgressToNextWizardStage() {
      return this.deviceManagementWizardCurrentStage.canProgress && !this.hasGatewayConnectionFailure
    },
    canGoToPreviousWizardStage() {
      return this.deviceManagementWizardIsInProgress && !this.hasGatewayConnectionFailure
    },
    showPreviousWizardStageButton() {
      return true
    },
    numberOfDeviceManagementWizardStages() {
      return this.deviceManagementWizardStages.length
    },
    isRebootGatewayAction() {
      return this.chosenDeviceManagementAction === DeviceManagementActions.RebootGateWay
    },
    isSetupWifiAction() {
      return this.chosenDeviceManagementAction === DeviceManagementActions.SetupWifi
    },
    showWizardProgressIndicator() {
      return !this.isRebootGatewayAction && !this.isSetupWifiAction
    },
    showWizardStageControls() {
      return !this.isRebootGatewayAction && !this.isSetupWifiAction
    },
    isFirstWizardStage() {
      return this.deviceManagementWizardCurrentStageIndex === 0
    },
    isLastWizardStage() {
      return this.deviceManagementWizardCurrentStageIndex === this.numberOfDeviceManagementWizardStages - 1
    },
    shouldPollCurrentGateway() {
      return (
        this.deviceManagementWizardIsInProgress &&
        !this.isSendingGatewayPollRequest &&
        !this.hasGatewayConnectionFailure
      )
    },
  },

  created() {
    this.initDeviceManagementWizard(DeviceManagementActions.CreatePackage)
  },

  mounted() {
    this.currentGatewayPollInterval = setInterval(() => {
      if (this.shouldPollCurrentGateway) {
        this.pollCurrentGateway()
      }
    }, Timeouts.FiveSeconds)
  },

  beforeDestroy() {
    clearInterval(this.currentGatewayPollInterval)
  },

  beforeRouteLeave(to, from, next) {
    if (this.deviceManagementWizardIsInProgress) {
      return next(this.confirmAbandonProgress())
    }
    next()
  },

  methods: {
    initDeviceManagementWizard(action, requireConfirmation = true) {
      if (this.deviceManagementWizardIsInProgress && requireConfirmation) {
        const confirmation = this.confirmAbandonProgress()
        if (!confirmation) {
          return
        }
      }
      //ensure key change to re-render wizard
      this.chosenDeviceManagementAction = 'rerender'
      this.$nextTick(() => {
        this.chosenDeviceManagementAction = action
      })
      this.buildWizardStages(action)
      this.buildAllDevices()
      this.resetWizardData()
    },
    async pollCurrentGateway() {
      this.isSendingGatewayPollRequest = true
      try {
        console.info(
          `[${moment().format('HH:MM:ss')}] this function will poll the current gateway (${
            this.currentGatewayId
          }) to ensure it is still connected`
        )
        setTimeout(() => {
          this.isSendingGatewayPollRequest = false
          this.hasGatewayConnectionFailure = false
          //this.hasGatewayConnectionFailure = true;
        }, 2000)
      } catch (err) {
        console.log(err)
        this.hasGatewayConnectionFailure = true
      }
    },
    deviceManagementWizardNextButtonAction() {
      this[this.deviceManagementWizardCurrentStage.nextButtonAction]()
    },
    [DeviceManagementWizardNextButtonActionNames.NextWizardStage](): void {
      if (this.isLastWizardStage) {
        return this.initDeviceManagementWizard(this.chosenDeviceManagementAction, false)
      }
      this.deviceManagementWizardCurrentStageIndex += 1
    },
    [DeviceManagementWizardNextButtonActionNames.NextSelectedDevice]() {
      const nextIndex = this.deviceManagementWizardCurrentSelectedDeviceIndex + 1
      if (nextIndex < this.deviceManagementWizardSelectedDevices.length) {
        return (this.deviceManagementWizardCurrentSelectedDeviceIndex += 1)
      }
      this[DeviceManagementWizardNextButtonActionNames.NextWizardStage]()
    },
    deviceManagementWizardBackButtonAction() {
      this[this.deviceManagementWizardCurrentStage.backButtonAction]()
    },
    [DeviceManagementWizardBackButtonActionNames.PreviousWizardStage](): void {
      this.deviceManagementWizardCurrentStageIndex -= 1
    },
    [DeviceManagementWizardBackButtonActionNames.PreviousSelectedDevice]() {
      if (this.deviceManagementWizardCurrentSelectedDeviceIndex >= 1) {
        return (this.deviceManagementWizardCurrentSelectedDeviceIndex -= 1)
      }
      this[DeviceManagementWizardBackButtonActionNames.PreviousWizardStage]()
    },
    updateCurrentGatewayId(payload: string): void {
      this.currentGatewayId = payload
    },
    updateSelectedDevices(payload): void {
      this.allDevices = payload
    },
    updateDeviceStatus(payload): void {
      this.$set(this.allDevices, payload.deviceIndex, payload)
    },
    updateStageValidity(payload: { stageIndex: number; isValid: boolean }): void {
      this.deviceManagementWizardIsInProgress = true
      this.deviceManagementWizardStages[payload.stageIndex].canProgress = payload.isValid
    },
    confirmAbandonProgress(): boolean {
      return confirm(
        `Progress may be lost if you leave the ${this.chosenDeviceManagementAction} workflow at this stage. Are you sure you wish to leave?`
      )
    },
    resetWizardData() {
      this.deviceManagementWizardIsInProgress = false
      this.hasGatewayConnectionFailure = false
      this.deviceManagementWizardCurrentStageIndex = 0
      this.deviceManagementWizardCurrentSelectedDeviceIndex = 0
    },
    buildWizardStages(action: string) {
      //NEEDS TYPING
      this.deviceManagementWizardStages = DeviceManagementWizardStages[action].map((stage, index) => ({
        ...stage,
        stageNumber: index + 1,
        canProgress: false,
      }))
    },
    buildAllDevices() {
      this.allDevices = this.deviceNames.map(
        (device, index): DeviceManagementAvailableDevice => ({
          ...DeviceManagementDefaultAvailableDevice,
          name: device,
          deviceIndex: index,
        })
      )
    },
  },
}
